<template>
	<div>
		<div class="list-group border-radius-2 no-border mb-3">
			<WidgetHeader link="/timetables/placements">{{ $t("placement-events") }}</WidgetHeader>
		</div>
		<button class="btn btn-dark" @click="downloadReport()">{{ $t("download") }}</button>
		<button class="btn btn-dark ml-1" @click="downloadAllReport()">{{ $t("download-all") }}</button>
		<SelectInput
			v-model="selectedmonth"
			@input="getPlacements()"
			:label="$t('months')"
			:options="months"
			:nullable="true"
			:nullLabel="$t('all')"
			optionValue="value"
			optionLabel="caption"
		/>
		<PlacementEventsList
			:placementevents="placementevents"
			@newMessageCallback="newMessage"
		></PlacementEventsList>
	</div>
</template>

<script>
import WidgetHeader from "src/components/widgets/WidgetHeader";
import PlacementEventsList from "src/components/Placements/PlacementEventsList";

export default {
	components: {
		WidgetHeader,
		PlacementEventsList
	},
	data() {
		return {
			total: 0,
			selectedmonth: null,
			months: [],
			placementevents: []
		};
	},
	mounted() {
		this.getPlacements();
		this.getPlacementMonths();
	},
	methods: {
		getPlacements(){
			var data = {};
			if(this.selectedmonth){
				data['year-month'] = this.selectedmonth
				data['page_size'] = 300
			} else {
				data.weeks = 4
			}
			this.$cfetch(`${this.$settings.APIBaseURL}/placements/myplacements`, {
				cache: false,
				method: 'post',
				data
			})
			.then(res => {
				if (res.status === "SUCCESS") {
					res.results.map(event => {
						event.students.map(student => {
							student.displayname = ''
						});
					});
					this.placementevents = res.results;
					this.placementevents.map(event => {
						event.students.map(student => {
							this.$users.getDisplayName.call(this , student.id).then(result => {
								student.displayname = result
							});
						});
					});
					this.total = res.pagination.total
				} else {
					this.$log.error.call(this, "Could not fetch placements");
				}
			})
			.catch(error => {
				this.$log.error.call(this, error);
			});
		},
		getPlacementMonths(){
			this.$cfetch(`${this.$settings.APIBaseURL}/placements/myplacements/months`, {
				cache: false,
				method: 'get'
			})
			.then(res => {
				if (res.status === "SUCCESS") {
					this.months = res.results.map(item => {
						var label = this.$t(`month-long-${item.month}`) + ' ' + item.year + ' (' + item.count + ')';
						return {
							'value': item['year-month'],
							'caption': label
						};
					});
				} else {
					this.$log.error.call(this, "Could not fetch placements");
				}
			})
			.catch(error => {
				this.$log.error.call(this, error);
			});
			
		},
		downloadReport() {
			let body = {
				username: this.$UserSession.getValue.call(this, "username"),
				authToken: this.$UserSession.getValue.call(this, "authToken"),
				download: 1
			};

			if (this.selectedmonth) {
				body['year-month'] = this.selectedmonth;
			} else {
				body.weeks = 4;
			}

			const url = `${this.$settings.APIBaseURL}/placements/myplacements?` + new URLSearchParams(body).toString();
			window.open(url);
		},
		downloadAllReport() {
			let body = {
				username: this.$UserSession.getValue.call(this, "username"),
				authToken: this.$UserSession.getValue.call(this, "authToken"),
				download: 1
			};

			const url = `${this.$settings.APIBaseURL}/placements/myplacements?` + new URLSearchParams(body).toString();
			window.open(url);
		},
		newMessage(recipients) {
			this.$store.commit("openModal", {
				type: "message",
				// title: this.$t("select-a-student")
				title: this.$t('new-message'),
				recipients: recipients
			});
		},
	}
};
</script>
